export enum ContentType {
  INGREDIENT = 'ingredient',
  RECIPE = 'recipe',
  REVIEWABLE = 'reviewable',
  DOCUMENT_EPISODE = 'documentEpisode',
}
